export const geocodeConstants = {
  FIND_ADDRESS_REQUEST: 'FIND_ADDRESS_REQUEST',
  FIND_ADDRESS_SUCCESS: 'FIND_ADDRESS_SUCCESS'
}
